import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ScrollTopWrapper } from './components/layout/ScrollTopWrapper';
import { Confirmation } from './components/pages/Confirmation';
import Constants from './constants';
import { AudienceDetailsBasicPage } from './containers/audience/AudienceDetailsBasicPage';
import { DistributionOptionsPage } from './containers/audience/DistributionOptionsPage';
import { AudienceListPage } from './containers/audiences/AudienceListPage';
import { ConfirmClientPage } from './containers/confirmClient/ConfirmClientPage';
import { AdminAudienceRouter } from './containers/layout/AdminAudienceRouter';
import { AdminRouter } from './containers/layout/AdminRouter';
import { BuilderLayoutContainer } from './containers/layout/BuilderLayout';
import { LayoutContainer } from './containers/layout/Layout';
import { actionCreators } from './containers/layout/LayoutStore';
import { BranchingAndLayoutPage } from './containers/pages/BranchingAndLayoutPage';
import { BrandingAndThemePage } from './containers/pages/BrandingAndThemePage';
import { ConfirmSchedulePage } from './containers/pages/ConfirmSchedulePage';
import { DefineSurveyContentPage } from './containers/pages/DefineSurveyContentPage';
import { DefineSurveyQuestionsPage } from './containers/pages/DefineSurveyQuestionsPage';
import { ManageSurveyDimensionsPage } from './containers/pages/ManageSurveyDimensionsPage';
import { ReportingSetupPage } from './containers/pages/ReportingSetupPage';
import { SurveyBasicsPage } from './containers/pages/SurveyBasicsPage';
import { SurveyCompletePage } from './containers/pages/SurveyCompletePage';
import { SurveyListPage } from './containers/pages/SurveyListPage';

export function Routes() {
	return (
		<ScrollTopWrapper>
			<Switch>
				<Route path={'/survey-admin/:surveyId/audience/:audienceId'} component={AdminAudienceRouter} />
				<Route path={'/survey-admin/:surveyId'} component={AdminRouter} />
				<Route exact={true} path={'/confirm-client'} component={ConfirmClientPage} />
				<Route path='/(basics|\d+/.+)'>
					<BuilderLayoutContainer {...actionCreators}>
						<Route exact={true} path={Constants.ROUTE_BASICS} component={SurveyBasicsPage} />
						<Route exact={true} path={'/:surveyId' + Constants.ROUTE_BASICS} component={SurveyBasicsPage} />
						<Route exact={true} path={'/:surveyId' + Constants.ROUTE_DEFINE_SURVEY_CONTENT} component={DefineSurveyContentPage} />
						<Route exact={true} path={'/:surveyId' + Constants.ROUTE_DEFINE_SURVEY_QUESTIONS} component={DefineSurveyQuestionsPage} />
						<Route exact={true} path={'/:surveyId' + Constants.ROUTE_MANAGE_SURVEY_DIMENSIONS} component={ManageSurveyDimensionsPage} />
						<Route exact path={'/:surveyId' + Constants.ROUTE_BRANDING_AND_THEME} component={BrandingAndThemePage} />
						<Route exact={true} path={'/:surveyId' + Constants.ROUTE_LOGIC_AND_LAYOUT} component={BranchingAndLayoutPage} />
						<Route exact={true} path={'/:surveyId' + Constants.ROUTE_AUDIENCES} component={AudienceListPage} />
						<Route exact={true} path='/:surveyId/audience/:audienceId?' component={AudienceDetailsBasicPage} />
						<Route exact={true} path='/:surveyId/audience/:audienceId/distribution-options' component={DistributionOptionsPage} />
						<Route exact={true} path={'/:surveyId' + Constants.ROUTE_REPORTING} component={ReportingSetupPage} />
						<Route exact={true} path={'/:surveyId' + Constants.ROUTE_CONFIRM_SCHEDULE} component={ConfirmSchedulePage} />
						<Route exact={true} path={'/:surveyId' + Constants.ROUTE_COMPLETE} component={SurveyCompletePage} />
					</BuilderLayoutContainer>
				</Route>
				<Route path={'/'}>
					<LayoutContainer {...actionCreators}>
						<Route exact={true} path='/' component={SurveyListPage} />
						<Route exact path={Constants.ROUTE_CONFIRMATION} component={Confirmation} />
					</LayoutContainer>
				</Route>
			</Switch>
		</ScrollTopWrapper>
	);
}
